import * as queryString from 'query-string';
import axios from 'axios';
import * as _ from 'lodash';

import {addUcCommonParam, getPageBizParam, funcGetLocationSearchObj, getCpParams} from './ucparam';
import {IEnvironment} from '../../middleware/envi';
import {IStoryData, IStoryDataOut} from '../../service/contentServer';
import {IStatStory} from '../../middleware/statStory';

function logServerFinal(urlParams, oneLog) {
  // console.log('logServerSend',data);
  let logServerHost = 'http://airlogserver.ucnews.ucweb.com';
  // https 只支持http://airlogserver.ucnews.ucweb.com这个域名
  // 如需要更换 请跟后端同学确认
  if (window.location.protocol === 'https:') {
    logServerHost = logServerHost.replace(/^http:\/\//, 'https://');
  }
  if (!urlParams.site) {
    return;
  }
  const url = logServerHost + '/' + urlParams.site +  '/api/v1/client_event?' + queryString.stringify(urlParams);
  if (navigator.sendBeacon) {
    navigator.sendBeacon(url, JSON.stringify({logs: [oneLog]}));
  } else {
    axios.request({
      url,
      method: 'POST',
      data: {logs: [oneLog]},

      responseType: 'text',
    }).then(function(response) {
      console.log(response);
    }).catch(function(error) {
      console.log(error);
    });

  }
}

export function logServer(oneLog, query?) {
  const locationSearchObj: any = funcGetLocationSearchObj();
  const params = addUcCommonParam({...getPageBizParam(), ...getCpParams(), ...query});
  // logServerFinal(params, oneLog);
  logServerFinal(_.merge({}, locationSearchObj, params), oneLog);
}

export function logDetailPvWhenNeeded(story?: IStoryData, envi?: IEnvironment, statStory?: IStatStory) {
  // push 和 deeplink 需要页端手动上报pv
  story = story || window._STORY.raw_item;
  envi = envi || window._ENVI_INFO;
  statStory = statStory || window._STAT_STORY;
  const q = queryString.parse(location.search, {arrayFormat: 'bracket'});

  // push
  if (q.entry1 && /^push/i.test(q.entry1 as string) && q.uc_biz_str) {
    logServer({
      ac: 'push',
      item_id: statStory.item_id,
      app: envi.app || 'browser_push',
      seed_site: story.seed_name,
      source: story.seed_site,
      cate_id: story.category_id && story.category_id[0] || '',
      entry1: q.entry1 || '',
      entry2: q.entry2 || '',
    });
    return ;
  }

  // 分享
  if (q.entry1 && (q.entry1 === 'share' || q.entry1 === 'shareback')) {
    logServer({
      ac: 'deeplink',
      item_id: statStory.item_id,
      app: envi.app,
      seed_site: story.seed_name,
      source: story.seed_site,
      reco_id: q.reco_id || '', // <推荐请求ID>，调iflow server的时候随文章数据返回的
      cate_id: story.category_id && story.category_id[0] || '',
      entry1: q.entry1 || '',
      entry2: q.entry2 || '',
    });
    return ;
  }
}
